import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BackofficeSessionService } from './backoffice-session.service';

export const backofficeAuthGuard: CanActivateFn = () => {
  const session = inject(BackofficeSessionService);
  const router = inject(Router);
  return session.isAuthenticated() ? true : router.createUrlTree(['/backoffice/session']);
};
